import * as theme from "../theme";
import { makeStyles } from "@material-ui/core/styles";
import { useRef, useState } from "react";
import { getBrokerInformation } from "../store/broker";
import { useDispatch, useSelector } from "react-redux";
// Adapted from AllInOnePage

const BugReportAllInOnePage = ({
  Scrollable,
  formQuestions,
  form,
  openFormId,
  onInput,
}) => {
  const mainDivRef = useRef(null);

  const useStyles = makeStyles(theme.customMaterialUIClassForScrollBar);
  const classes = useStyles();
  const initialScrollBarThickness = "0.5vw";
  const firstDivHeight = "12%";
  const secondDivHeight = "88%";
  const thirdDivHeight = `calc(100% - ${firstDivHeight} - ${secondDivHeight})`;
  const spaceBetweenScroll = "1.7vw";
  const leftRightMargin = theme.SCALES.letfRighMarginInQuestionArea;
  const brokerInformation = useSelector(getBrokerInformation);
  const languagepreference =
    brokerInformation?.information?.languagepreference || "en";

  const [showScroll, setShowScroll] = useState(false);

  const handleShowScroll = (value) => {
    setShowScroll(value);
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        backgroundColor: theme.COLORS.tertiary_lightbackground,
      }}
    >
      <div
        style={{
          width: "100%",
          height: firstDivHeight,
          paddingLeft: leftRightMargin,
          paddingRight: leftRightMargin,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            fontFamily: "GibsonSemiBd",
            letterSpacing: 1,
            color: theme.COLORS.primary_navyblue,
            fontSize: "2.3vmin",
          }}
        >
          {formQuestions[openFormId].title[languagepreference]}
        </div>
      </div>
      <div
        style={{
          width: "100%",
          height: secondDivHeight,
          paddingRight: showScroll
            ? `calc(${leftRightMargin} - ${spaceBetweenScroll} - ${initialScrollBarThickness})`
            : `calc(${leftRightMargin} - ${spaceBetweenScroll})`,
          paddingLeft: leftRightMargin,
        }}
      >
        <div
          ref={mainDivRef}
          style={{
            width: "100%",
            height: "100%",
            paddingRight: spaceBetweenScroll,
            overflow: "auto",
          }}
          className={classes.responses}
        >
          <Scrollable
            mainDivRef={mainDivRef}
            handleShowScroll={handleShowScroll}
            formQuestions={formQuestions}
            form={form}
            openFormId={openFormId}
            onInput={onInput}
          ></Scrollable>
        </div>
      </div>
      <div style={{ width: "100%", height: thirdDivHeight }}></div>
    </div>
  );
};

export default BugReportAllInOnePage;
